import React, { useEffect, useRef, useState } from 'react';
import { Button, Groupper, Header, Message, Modal } from 'react-frontier';
import DetailsList from './DetailsList';
import { EmploymentLogType, EmploymentScheduleType, Schedule } from '../Classes';
import { getLocation, minutesToClock, pad, toTimeString } from '../Util';
import API from '../API';
import moment from 'moment';

var Check =()=>{
	var [schedule, setSchedule] = useState<Schedule | null>(null);
	var [loadError, setLoadError] = useState<string | null>(null);
	var [initialLoading, setInitialLoading] = useState(true);
	var [actionLoading, setActionLoading] = useState(false);
	var [actionError, setActionError] = useState<string | null>(null);
	var [confirmCheckin, setConfirmCheckin] = useState(false);
	var [confirmCheckout, setConfirmCheckout] = useState(false);
	var [elapsed, setElapsed] = useState({ h: 0, m: 0, s: 0 });
	var timerRef = useRef<number | null>(null);

	var load =()=>{
		setLoadError(null);
		API.getCheckinToday().then((res)=>{
			if(res.error) return setLoadError(res.message || 'Error al cargar el turno.');
			setSchedule(res.data?.schedule_id ? res.data : null);
		}).catch(()=>{
			setLoadError('Error inesperado al cargar el turno.');
		}).finally(()=>{
			setInitialLoading(false);
		});
	};

	useEffect(()=>{
		load();
	}, []);

	useEffect(()=>{
		if(timerRef.current) clearInterval(timerRef.current);
		if(!schedule?.log_id || !schedule.date_start || schedule.date_end || schedule.log_type_id || schedule.type_id === EmploymentScheduleType.REST) return;

		var tick =()=>{
			var diff = Math.max(0, moment().unix() - schedule.date_start!);
			setElapsed({ h: Math.floor(diff / 3600), m: Math.floor((diff % 3600) / 60), s: diff % 60 });
		};
		tick();
		timerRef.current = window.setInterval(tick, 1000);
		return ()=> { if(timerRef.current) clearInterval(timerRef.current); };
	}, [schedule]);

	var doCheckIn =()=>{
		if(!schedule || actionLoading) return;
		setConfirmCheckin(false);
		setActionLoading(true);
		setActionError(null);

		getLocation().then((coords)=>
			API.checkIn(schedule.schedule_id, moment().unix(), coords.latitude, coords.longitude)
		).then((res)=>{
			if(res.error) return setActionError(res.message || 'Error al registrar entrada.');
			load();
		}).catch((err)=>{
			setActionError(err?.message || 'Error inesperado.');
		}).finally(()=> setActionLoading(false));
	};

	var doCheckOut =()=>{
		if(!schedule?.log_id || actionLoading) return;
		setConfirmCheckout(false);
		setActionLoading(true);
		setActionError(null);

		getLocation().then((coords)=>
			API.checkOut(schedule.log_id!, moment().unix(), coords.latitude, coords.longitude)
		).then((res)=>{
			if(res.error) return setActionError(res.message || 'Error al registrar salida.');
			load();
		}).catch((err)=>{
			setActionError(err?.message || 'Error inesperado.');
		}).finally(()=> setActionLoading(false));
	};

	if(initialLoading) return (
		<div className="team-check-screen">
			<Header size='small' centered loading text="Cargando turno" />
		</div>
	);

	if(loadError) return (
		<div className="team-check-screen">
			<Header
				centered
				size='small'
				text="No pudimos cargar tu turno"
				subtext={loadError}
				iconName="face-frown-open"
				actions={<Button as="button" type="button" text="Reintentar" color="black" nativeOnClick={load} />}
			/>
		</div>
	);

	var isIncidence = !!schedule?.log_type_id;
	var isRest = !isIncidence && schedule?.type_id === EmploymentScheduleType.REST;
	var isActive = !!(schedule?.log_id && schedule.date_start && !schedule.date_end && !isIncidence);
	var isCompleted = !!(schedule?.log_id && schedule.date_end && !isIncidence);
	var nowMinutes = moment().hours() * 60 + moment().minutes();
	var isMissed = !!(schedule && !schedule.log_id && !isRest && nowMinutes > schedule.time_end);
	var incidenceColor = (() => {
		switch(schedule?.log_type_id){
			case EmploymentLogType.VACATIONS: return '#4C82F7';
			case EmploymentLogType.PERMISSION: return '#D18A2A';
			case EmploymentLogType.AUTHORIZED_REST: return '#C6A300';
			case EmploymentLogType.DISABILITY: return '#C65B5B';
			default: return '#4C82F7';
		}
	})();
	var incidenceLabel = schedule?.log_type_name || 'Incidencia autorizada';

	var shiftMinutes = schedule ? schedule.time_end - schedule.time_start : 480;
	var circleR = 88;
	var circumference = 2 * Math.PI * circleR;

	if(!schedule) return (
		<div className="team-check-screen" style={{ paddingTop: 16 }}>
			<Header
				centered
				text="Sin turnos asignados"
				subtext="No hay turnos programados para hoy."
				iconName="calendar-day"
				style={{ marginTop: 0, marginBottom: 0 }}
			/>
		</div>
	);

	return <div className="team-check-screen">
		<Groupper title="Mi turno" titleSize="small" style={{ margin: 0, padding: 0 }}>
			<div className="team-progress-circle-wrap">
				<div className="team-progress-circle">
					{(isIncidence || isRest) ? (
						<div className="team-progress-button active" style={{ cursor: 'default' }}>
							<div style={{ marginTop: 8, fontSize: 15, fontWeight: 700, color: isRest ? '#C6A300' : incidenceColor }}>{isRest ? 'Descanso' : incidenceLabel}</div>
							<div style={{ marginTop: 8, fontSize: 13, lineHeight: 1.5, color: '#68635e', padding: '0 18px' }}>
								{schedule.notes || (isRest ? 'Hoy tienes un descanso programado.' : 'Hoy no necesitas registrar asistencia.')}
							</div>
						</div>
					) : (isActive || isCompleted) ? (()=>{
						var finalDiff = isCompleted
							? schedule.date_end! - schedule.date_start!
							: elapsed.h * 3600 + elapsed.m * 60 + elapsed.s;
						var fh = Math.floor(finalDiff / 3600);
						var fm = Math.floor((finalDiff % 3600) / 60);
						var fs = finalDiff % 60;
						var finalProgress = Math.min((finalDiff / 60 / shiftMinutes) * 100, 100);
						return <>
							<svg className="team-progress-svg" viewBox="0 0 192 192" aria-hidden="true">
								<circle cx="96" cy="96" r={circleR} fill="none" stroke="#E7E3DD" strokeWidth="10" />
								<circle cx="96" cy="96" r={circleR} fill="none" stroke={isCompleted ? '#8d8882' : '#5FA17A'} strokeWidth="10" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={circumference * (1 - finalProgress / 100)} />
							</svg>
							<button className="team-progress-button active" type="button" onClick={isActive ? () =>setConfirmCheckout(true) : undefined} disabled={isCompleted || actionLoading} style={isCompleted ? { cursor: 'default' } : {}}>
								<div style={{ marginTop: 12, fontSize: 32, fontWeight: 700, color: isCompleted ? '#8d8882' : '#1d1b19' }}>{pad(fh)}:{pad(fm)}:{pad(fs)}</div>
								<div style={{ marginTop: 4, fontSize: 12, color: '#8d8882' }}>{isCompleted ? 'finalizado' : 'en curso'}</div>
								<div style={{ fontSize: 14, lineHeight: 1, fontWeight: 600, color: isCompleted ? '#8d8882' : '#1d1b19' }}>{Math.round(finalProgress)}%</div>
							</button>
						</>;
					})() : (
						<Button
							as="button"
							type="button"
							text={actionLoading ? '...' : isMissed ? 'Turno perdido' : 'Check-In'}
							color={isMissed ? 'black' : 'orange'}
							className="team-progress-button idle"
							disabled={isMissed || actionLoading}
							nativeOnClick={!isMissed ? () => setConfirmCheckin(true) : undefined}
						/>
					)}
				</div>
			</div>
			<div style={{ margin: '0 0 20px', textAlign: 'center', fontSize: 14, lineHeight: 1.55, color: '#68635e' }}>
				{isIncidence ? 'Tu asistencia de hoy ya está resuelta con una incidencia autorizada.' : isRest ? 'Hoy tienes un descanso programado.' : isCompleted ? 'Turno finalizado.' : isActive ? 'Turno laboral en progreso.' : isMissed ? 'El turno ya expiró.' : 'Presiona para iniciar tu turno.'}
			</div>
			{(isActive || isCompleted) && <div className="team-time-grid">
				<div>
					<div style={{ fontSize: 12, color: '#8d8882', marginBottom: 4 }}>Entrada</div>
					<div style={{ fontSize: 18, fontWeight: 700 }}>{schedule.date_start ? toTimeString(schedule.date_start) : '—'}</div>
				</div>
				<div style={{ textAlign: 'right' }}>
					<div style={{ fontSize: 12, color: '#8d8882', marginBottom: 4 }}>Salida</div>
					<div style={{ fontSize: 18, fontWeight: 700 }}>{schedule.date_end ? toTimeString(schedule.date_end) : '—'}</div>
				</div>
			</div>}
			{isActive && <Button
				type="button"
				text={actionLoading ? '...' : 'Finalizar turno'}
				color="red"
				fluid
				disabled={actionLoading}
				onClick={()=> setConfirmCheckout(true)}
				style={{ marginTop: 4 }}
			/>}
			{actionError && <Message type="error" header="No pudimos completar la acción" text={actionError} style={{ marginTop: 12 }} />}
			{schedule && <>
				<Groupper.Divider
					type="line text"
					text="Detalles del turno"
					textStyle={{ fontWeight: 600, fontSize: 16, color: '#5f5a55' }}
				/>
				<DetailsList items={[
					{ id: 'position', overline: 'Puesto', label: schedule.employment_name, iconName: 'briefcase' as const },
					{ id: 'schedule', overline: 'Horario', label: `${minutesToClock(schedule.time_start)} - ${minutesToClock(schedule.time_end)}`, iconName: 'clock' as const },
					{ id: 'salary', overline: 'Salario', label: `$${schedule.salary.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`, iconName: 'money-bill-wave' as const },
					...(isIncidence ? [{ id: 'type', overline: 'Incidencia', label: incidenceLabel, supporting: schedule.notes || undefined, iconName: 'calendar-day' as const }] : []),
					...(isRest ? [{ id: 'type', overline: 'Tipo de horario', label: 'Descanso', supporting: schedule.notes || undefined, iconName: 'calendar-day' as const }] : []),
				]} />
			</>}
		</Groupper>
		<Modal open={confirmCheckin} onClose={setConfirmCheckin} size='tiny'>
			<Modal.Header>Confirmar entrada</Modal.Header>
			<Modal.Content>¿Estás seguro de que deseas registrar tu entrada?</Modal.Content>
			<Modal.Actions>
				<Button as="button" type="button" basic text='Cancelar' onClick={() => setConfirmCheckin(false)} />
				<Button as="button" type="button" color='orange' text='Sí, confirmar' onClick={doCheckIn} loading={actionLoading} />
			</Modal.Actions>
		</Modal>
		<Modal open={confirmCheckout} onClose={setConfirmCheckout} size='tiny'>
			<Modal.Header>Confirmar salida</Modal.Header>
			<Modal.Content>¿Estás seguro de que deseas registrar tu salida?</Modal.Content>
			<Modal.Actions>
				<Button as="button" type="button" basic text='Cancelar' onClick={()=> setConfirmCheckout(false)} />
				<Button as="button" type="button" color='red' text='Sí, finalizar' onClick={doCheckOut} loading={actionLoading} />
			</Modal.Actions>
		</Modal>
	</div>;
};

export default Check;
